const { NavigateBefore } = require("@mui/icons-material");
const {
  DialogTitle,
  Typography,
  DialogContent,
  DialogActions,
  colors,
  Button,
  Dialog,
} = require("@mui/material");
const { GradientButton } = require("components/GradientButton");

const CustomizeDialog = ({
  open,
  onClose,
  onSave,
  disabledSave = false,
  title = "รายละเอียดรถ",
  children,
  loading = false,
  actions,
  size = "md",
  isShowSubmit = true,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={size}
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          padding: 2,
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h4">{title}</Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          padding: 2,
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: 8,
            height: 8,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: colors.grey[300],
            borderRadius: 4,
          },
        }}
      >
        {children}
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "space-between",
          borderTop: `1px solid ${colors.grey[300]}`,
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            borderRadius: 2,
            width: "auto",
            borderColor: colors.grey[400],
            color: colors.grey[400],
            "&:hover": {
              borderColor: colors.grey[400],
              color: colors.grey[400],
              borderWidth: 2,
              bgcolor: "transparent",
            },
          }}
        >
          <NavigateBefore
            sx={{
              width: 30,
              height: 30,
            }}
          />
        </Button>

        {!isShowSubmit ? (
          <></>
        ) : disabledSave ? (
          <Button
            variant="contained"
            sx={{
              width: "auto",
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            type="submit"
            disabled
          >
            <Typography sx={{ fontSize: "16px" }}>บันทึก</Typography>
          </Button>
        ) : (
          <GradientButton
            onClick={onSave}
            sx={{
              width: "auto",
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            type="submit"
            disabled={loading}
            loading={loading}
          >
            <Typography sx={{ fontSize: "16px" }}>บันทึก</Typography>
          </GradientButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CustomizeDialog;
